import { render } from "./mTable.vue?vue&type=template&id=b915384e&scoped=true"
import script from "./mTable.vue?vue&type=script&lang=js"
export * from "./mTable.vue?vue&type=script&lang=js"

import "./mTable.vue?vue&type=style&index=0&id=b915384e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b915384e"]])

export default __exports__